import React from 'react';
import { Autocomplete, Box, Chip, FormLabel, Stack, TextField, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import moment from 'moment';
import dayjs from 'dayjs';
import ccs from 'countrycitystatejson';
import { GOOGLEMAPSAPIKEY } from '../../../config';
import MapMarker from 'src/container/MapsBar/MapMarker';
import GoogleMapReact from 'google-map-react';

const DateLocationCard = (props) => {
  const { locList } = props;
  const pLoc = locList.map((loc) => ({
    value: loc.id,
    title: loc.location_addr1 + ' ' + loc.location_addr2 + ', ' + loc.location_city + ', ' + loc.location_state + ', ' + loc.location_zip,
  }));

  const code = ccs.getCountryByShort('US');

  const isLocked = (loc) => (!props.taskList ? false : props.taskList.some((task) => ((task.tas_is_active === 0 || task.tas_is_active === 1) && task.tas_loc_id === loc.locId)));

  const priceError = props.submitAttempted && (props.formVals.pPrice === '' || props.formVals.pPrice == null);
  const locError = props.submitAttempted && (!props.pLocations || props.pLocations.length === 0);

  return (
    <Stack spacing={2}>
      <Box sx={{ display: 'flex', gap: 1.5 }}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Start Date"
            disabled={props.edit}
            value={new Date(moment(props.formVals.pstrtDate))}
            onChange={(d) => props.handledateLocationChange({ target: { value: dayjs(d).format('YYYY-MM-DDTHH:mm:ss'), id: 'pstrtDate' } })}
            slotProps={{ textField: { variant: 'outlined', size: 'small', fullWidth: true } }}
          />
        </LocalizationProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="End Date"
            value={new Date(moment(props.formVals.pEndDate))}
            onChange={(d) => props.handledateLocationChange({ target: { value: dayjs(d).format('YYYY-MM-DDTHH:mm:ss'), id: 'pEndDate' } })}
            slotProps={{ textField: { variant: 'outlined', size: 'small', fullWidth: true } }}
          />
        </LocalizationProvider>
      </Box>

      <Autocomplete
        id="pLoc"
        fullWidth
        size="small"
        value={null}
        getOptionKey={(option) => option.value}
        onChange={(e, newValue) => {
          const value = newValue ? pLoc.find((loc) => loc.title === newValue.title) : null;
          if (value) props.handleMultipleLoc({ target: { value: value.value, id: 'pLoc' } });
        }}
        options={pLoc}
        getOptionLabel={(option) => option.title}
        renderInput={(params) => <TextField {...params} label="Location" variant="outlined" required error={locError} helperText={locError ? 'At least one location is required' : ''} />}
      />

      {(props.mapRender === 'proj' || props.edit) && (
        <Box sx={{ height: 240, borderRadius: 1, overflow: 'hidden' }}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: GOOGLEMAPSAPIKEY }}
            center={[40.735657, -74.172363]}
            defaultZoom={10}
            options={{ fullscreenControl: false, mapTypeControl: false }}
            yesIWantToUseGoogleMapApiInternals
          >
            {props.pLocations && props.pLocations.length !== 0 && props.pLocations.map((loc) => (
              <MapMarker
                key={loc.locId || loc.id}
                lat={loc.location_lat}
                lng={loc.location_lon}
                text={loc.location_addr1 + ' ' + loc.location_addr2 + ', ' + loc.location_city + ', ' + loc.location_state + ', ' + loc.location_zip}
                onClick={() => {}}
              />
            ))}
          </GoogleMapReact>
        </Box>
      )}

      <Box>
        <FormLabel component="legend" sx={{ fontSize: '0.85rem', mb: 0.75, display: 'block' }}>
          Selected Locations
        </FormLabel>
        {(!props.pLocations || props.pLocations.length === 0) ? (
          <Typography variant="caption" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
            No location selected
          </Typography>
        ) : (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
            {props.pLocations.map((loc) => (
              <Chip
                key={loc.locId}
                label={loc.location_addr1 + ' ' + loc.location_addr2 + ', ' + loc.location_city + ', ' + loc.location_state + ', ' + loc.location_zip}
                onDelete={isLocked(loc) ? undefined : () => props.onLocDelete(loc.locId)}
                variant="outlined"
                sx={{ maxWidth: '100%', borderColor: '#1976d2', color: '#1f3a5f' }}
              />
            ))}
          </Box>
        )}
      </Box>

      <Box sx={{ display: 'flex', gap: 1.5 }}>
        <TextField
          sx={{ flex: 1 }}
          size="small"
          variant="outlined"
          label="Price"
          value={props.formVals.pPrice ?? 0}
          onChange={props.handledateLocationChange}
          id="pPrice"
          required
          type="number"
          error={priceError}
          helperText={priceError ? 'Price is required' : ''}
        />
        <TextField
          sx={{ flex: 1 }}
          size="small"
          variant="outlined"
          label="Currency"
          value={`${code.emoji} ${code.name}(${code.currency})`}
          id="pCurrency"
          disabled
          inputProps={{ maxLength: 50 }}
        />
      </Box>
    </Stack>
  );
};

export default DateLocationCard;
